import { initializeSentry } from '@/scripts/services/sentry';

initializeSentry();
